import pressedKey from '../utils/pressedKey'

const pressedValidKey = pressedKey('space', 'enter')

export default handle => ({
  on: ['click', 'keyup'],
  handle (event) {
    if (event.keyCode) {
      if (!pressedValidKey(event)) return true

      event.preventDefault()
    }

    if (typeof handle === 'function') {
      handle.call(this, event)
    } else if (typeof handle === 'string') {
      this[handle](event)
    }
  },
})
